module.exports = require("classnames");


//////////////////
// WEBPACK FOOTER
// external "classnames"
// module id = 3
// module chunks = 0